import qs from "qs";
import { Navigate, useParams } from "react-router";
import ObjectDetailsPage from "../ObjectDetailsPage";

const GenericObjectDetailsPage = () => {
  const { id, type } = useParams();

  if (!id || !type) {
    return <Navigate to=".." />;
  }

  return <ObjectDetailsPage objectId={id} objectType={type} backButtonPath={`..?${qs.stringify({ type })}`} />;
};

export default GenericObjectDetailsPage;
